import styles from './style.module.css';
import Modal from 'react-responsive-modal';

interface IModalPerformanceSucced {
  modalIsOpen: boolean;
  performance: number;
  toggleModal: () => void;
}

export function ModalPerformanceSucced({
  modalIsOpen,
  performance,
  toggleModal,
}: IModalPerformanceSucced) {
  return (
    <Modal
      open={modalIsOpen}
      onClose={() => {
        toggleModal();
      }}
      center
    >
      <div className={`${styles.modalBanner} ${styles.modalBannerSuccess}`}>
        <i className="material-icons-outlined">emoji_events</i>
      </div>
      <div className={styles.contents}>
        <h2 className={styles.titleSuccess}>Parabéns! 🎉</h2>
        <p className={styles.detail}>
          Você conseguiu performar <strong>{performance}%</strong> neste quiz.
        </p>
        <p className={styles.caption}>
          Continue acompanhando as novidades por aqui!
        </p>
      </div>
      <div className={styles.contentBtn}>
        <button
          onClick={() => {
            toggleModal();
          }}
          className={styles.btnSuccess}
          type="button"
        >
          Concluir
        </button>
      </div>
    </Modal>
  );
}
